import { Vendor } from "api";
import { Credentials } from "auth";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";
import { ErrorPayload } from "./ErrorAction";

export type AdminFetchVendors = "ADMIN_FETCH_VENDORS";
export const ADMIN_FETCH_VENDORS: AdminFetchVendors = "ADMIN_FETCH_VENDORS";
export type AdminFetchVendorsEnd = "ADMIN_FETCH_VENDORS_END";
export const ADMIN_FETCH_VENDORS_END: AdminFetchVendorsEnd = "ADMIN_FETCH_VENDORS_END";

export interface AdminFetchVendorsAction extends Action {
    type: AdminFetchVendors;
    payload: {
        credentials: Credentials;
    };
}

export function adminFetchVendors(): ThunkAction<any, State, any, AdminFetchVendorsAction> {
    return (dispatch: Dispatch<AdminFetchVendorsAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(adminFetchVendorsWithCredentials(credentials));
    };
}

function adminFetchVendorsWithCredentials(credentials: Credentials): AdminFetchVendorsAction {
    return {
        payload: {
            credentials
        },
        type: ADMIN_FETCH_VENDORS
    };
}

export interface AdminFetchVendorsPayload extends ErrorPayload {
    vendors: Vendor[];
}

export interface AdminFetchVendorsEndAction extends Action {
    type: AdminFetchVendorsEnd;
    payload: {
        error?: Error;
        vendors?: Vendor[];
    };
}

export function adminFetchVendorsEnd(error: Error, vendors?: Vendor[]): AdminFetchVendorsEndAction {
    return {
        payload: {
            error,
            vendors
        },
        type: ADMIN_FETCH_VENDORS_END
    };
}
